module.exports = __webpack_public_path__ + "static/media/mati.05a94111.png";